export const neck = (() => {
    const placeHolderText = 'supple without adenopathy'

    return placeHolderText
})